import { fields } from '@codeleap/form'
import { form } from '@codeleap/form'
import { login } from './login'

export const forgotPassword = form('forgotPassword', {
  email: fields.text(login.fields.email.options),
  tester: login.fields.tester,
})